import React from 'react';

import style from './header.module.scss';

export const Header = ({ path }) => {
    function isCurrentPage(link) {
        return path === link;
    }

    function getLinkClassName(link) {
        return isCurrentPage(link) ? style.menuCurrentPageLink : style.menuLink;
    }

    return (
        <div className={style.header}>
            <div className={style.brand}>
                <img alt="Logo" src={process.env.PUBLIC_URL + '/assets/image/header/logo-header.png'} />
            </div>
            <nav className={style.menu}>
                <div className={style.menuItem}>
                    <a className={getLinkClassName('/')} href="/">
                        Home
                    </a>
                </div>

                <div className={style.menuItem}>
                    <a className={getLinkClassName('/products')} href="/products">
                        Products
                    </a>
                </div>

                <div className={style.menuItem}>
                    <a className={`${getLinkClassName('/about')}`} href="/about">
                        About Us
                    </a>
                </div>

                <div className={style.menuItem}>
                    <a className={getLinkClassName('/contact')} href="/contact">
                        Contact Us
                    </a>
                </div>
            </nav>
        </div>
    );
};
